import { Form, Input, Button, Alert, Row, Col, Card } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { HeartOutlined } from "@ant-design/icons";
import { SignedInDoctor } from "../auth/interfaces";
import { SignedInContext } from "../AppEnv";
import CardTut from "./CardTut";
import "../exams/tutoButtonYou.css";
import TutorialButtonYouTube from "../exams/TutorialButtonYouTube";

const TutorialInfo = () => {
  const srcurl = "URL_del_tuo_video"; // Sostituisci con l'URL effettivo del video
  const titolo = "Titolo del tuo video"; // Sostituisci con il titolo effettivo
  const descrizione = "Descrizione del tuo video"; // Sostituisci con la descrizione effettiva

  const [widths, setWidths] = useState(0);
  const handleResize = () => setWidths(window.innerWidth);

  useEffect(() => {
    //mount
    window.addEventListener("resize", handleResize);
    setWidths(window.innerWidth);
    //unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const TutorialCards = ({ widths }: { widths: number }) => (
    <>
      <CardTut
        width={widths}
        srcurl={
          "https://www.youtube.com/embed/pvsd5pCFcbE?si=JZhx-_hPMfGRd2et"
        }
        titolo={"Spiegazione Generale sul funzionamento."}
        descrizione={
          "In questo Tutorial andremo a vedere i funzionamenti principali di PhysiocheckApp, come utilizzare le varie funzionalità disponibili e come espostare un report in PDF."
        }
      />

      <CardTut
        width={widths}
        srcurl={
          "https://www.youtube.com/embed/2AbnXk3Rmzg?si=6pgQe6uyI7b9EC1e"
        }
        titolo={"Sistema Policettivo: Come funziona?"}
        descrizione={
          "Scopri come questo sistema può essere applicato con successo in una vasta gamma di patologie ortopediche, neurologiche, degenerative e usurate, offrendo una soluzione completa e efficace per il recupero e la riabilitazione."
        }
      />

      <CardTut
        width={widths}
        srcurl={
          "https://www.youtube.com/embed/nlmg0rKF7nE?si=AAGqeE918IGaCq4D"
        }
        titolo={"Pacchetto Riabilitativo | GKBOX®"}
        descrizione={
          "In questo breve video andremo ad illustrate come creare un pacchetto riabilitativo con GKBOX® per centri e professionisti del settore."
        }
      />

      <CardTut
        width={widths}
        srcurl={
          "https://www.youtube.com/embed/UyS_7zSFOpo?si=C5dEVBc8UoHtbR5u"
        }
        titolo={"Esempi di utilizzo: Elicoidali Parte 1"}
        descrizione={
          "Questo tipo di approccio è stato utilizzato in maniera assolutamente efficace anche nella cura delle lombalgie, algie osteo-artro-muscolari in genere e in patologie neurologiche di carattere degenerativo, come il Parkinson e le varie forme di atassie, oltre ad altre svariate problematiche. "
        }
      />
    </>
  );

  return (
    <>
      <Row className="bodyxx">
        

       {TutorialCards({ widths })}
       {/* <TutorialButtonYouTube /> */}
        <Row>
          <div className="leftos">
            <button
              className="buttonxo"
              onClick={() =>
                (window.location.href =
                  "https://www.youtube.com/@PhysiocheckApp")
              }
            >
              <span className="icon">
                <svg
                  fill="none"
                  height="33"
                  viewBox="0 0 120 120"
                  width="33"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m120 60c0 33.1371-26.8629 60-60 60s-60-26.8629-60-60 26.8629-60 60-60 60 26.8629 60 60z"
                    fill="#cd201f"
                  ></path>
                  <path
                    d="m25 49c0-7.732 6.268-14 14-14h42c7.732 0 14 6.268 14 14v22c0 7.732-6.268 14-14 14h-42c-7.732 0-14-6.268-14-14z"
                    fill="#fff"
                  ></path>
                  <path d="m74 59.5-21 10.8253v-21.6506z" fill="#cd201f"></path>
                </svg>
              </span>
              <span className="text1">Canale Youtube</span>
              <span className="text2">Visitalo!</span>
            </button>
          </div>
        </Row>
      </Row>
    </>
  );
};

export default TutorialInfo;
